import Career from "wwg-utilities/dist/collections/career";
import GetCareersDTO from "wwg-utilities/dist/dtos/get-careers.dto";
import apiClient from "./axiosClient";

const getCareersRequest = async (
  params: GetCareersDTO = { catalog: "all" }
): Promise<Career[]> => {
  return apiClient.get(`careers`, { params }).then((res) => res.data);
};

export default getCareersRequest;
